import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Components/signup.css";
import { Footer } from "./footer";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { LoadingSpinner } from "./loading";
import { BASE_URL as api } from "../services";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
export const Signup = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(null);
  const [conpass, setConpass] = useState(null);
  const [newOTP, setNewOTP] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, isLoading] = useState(false);
  const Submit = async (e) => {
    e.preventDefault();
    isLoading(true);
    try {
      if (password === conpass && password !== null) {
        const result = await axios.post(
          api+ "/signup",
          {
            email,
            password,
          }
        );
        console.log(result);
        if (result.data) {
          if (result.data === "have") {
            toast.info("already have an account");
            window.location.href = "/";
          } else {
            toast.success("Successfully signed up ");
          }

          nav("/?page=true");
        } else {
          toast.error("Something went wrong try again");
        }
      } else {
        toast.error(
          "Password must be matched with confirm password or enter password "
        );
        return false;
      }
    } catch (e) {
      // console.log(e);
      toast.error("User with this email already exists");
    } finally {
      isLoading(false);
      nav("/", { replace: true });
    }
  };
  function handlePassword(event) {
    const new_pass = event.target.value;
    setPassword(new_pass);
    var lowerCase = /[a-z]/g;
    var upperCase = /[A-Z]/g;
    var numbers = /[0-9]/g;
    if (!new_pass.match(upperCase)) {
      setErrorMessage("Password should contain uppercases!");
    } else if (!new_pass.match(lowerCase)) {
      setErrorMessage("Password should contain lowercase!");
    } else if (!new_pass.match(numbers)) {
      setErrorMessage("Password should contains numbers also!");
    } else if (new_pass.length < 6) {
      setErrorMessage("Password length should be more than 6.");
    } else {
      setErrorMessage("");
    }
  }
  const [cperrormsg, setcperrormsg] = useState("");
  const [passValid, setPassVaild] = useState();
  function handleConPassword(event) {
    const con_pass = event.target.value;
    setConpass(con_pass);
    if (password === con_pass) {
      setcperrormsg("Password matched");
      setPassVaild(false);
    } else {
      setcperrormsg("Password must be matched");
      setPassVaild(true);
    }
  }


  const SendOTP = async () => {
    isLoading(true);
    try {
      const response = await axios.get(api+"/send-otp", {
        params: {
          email
        }
      });
      if (response.status === 200) {
        toast.success("OTP sent to email successfully. Kindly review your Email's spam or bin folder for the OTP.");
        document.getElementById("send").disabled = true;
        document.getElementById("verify").disabled = false;
        setTimeout(() => {
          document.getElementById("send").disabled = false;
        }, 30000);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
      isLoading(false);
    }
  };
  
  const verifyOTP = async() => {
    isLoading(true);
    try {
      const response = await axios.post(api+'/verify-otp', {
    
          email,
          otp:newOTP
      });


      if(response.data.message){
        toast.success(response.data.message);
      }
      else{
        toast.error(response.data.error);

      }
 
    } catch (error) {
      // console.error(error);
      toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
      isLoading(false);
    }
  };

  const showPassword = (inputId) => {
    var input = document.getElementById(inputId);
    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  };

  return (
    <>
      <LoadingSpinner state={loading} />

      <div className="signup-body">
        <Navbar
          expand="lg"
          className="navbar navbar-expand-sm bg-dark navbar-dark"
        >
          <Container>
            <Navbar.Brand href="/">
              <img
                alt=""
                src="./myport.png"
                width="40"
                height="40"
                className="d-inline-block align-top"
              />{" "}
              <i className="fa-solid ">My Portfolio</i>
            </Navbar.Brand>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto"></Nav>
              <Nav></Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <section className="register-container">
          <div className="container signup-container">
            <div className="title">Registration</div>
            <div className="content">
              <div className="form">
                <div className="user-details ">
                  <div className="input-box">
                    <span className="details">Email</span>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Password</span>
                    <input
                      type="password"
                      id="showPassword"
                      placeholder="Enter your password"
                      value={password}
                      required
                      onChange={handlePassword}
                    />
                  </div>
                  <div className="d-flex justify-content-between w-100 ">
                  <div className="passvalidation">{errorMessage}</div>
                  <div className="form-check text-start ">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onClick={() => showPassword("showPassword")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Show Password
                    </label>
                  </div>
                  </div>
                 
                  <div className="input-box">
                    <span className="details">Confirm Password</span>
                    <input
                      type="password"
                      id="showConfirmPassword"
                      placeholder="Confirm your password"
                      value={conpass}
                      required
                      onChange={handleConPassword}
                    />
                  </div>
                  <div className="d-flex justify-content-between w-100 ">
                    
                  {passValid === true ? (
                    <div className="passvalidation">{cperrormsg}</div>
                  ) : (
                    <div className="passvalidationdone">{cperrormsg}</div>
                  )}
                  <div className="form-check text-start ">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onClick={() => showPassword("showConfirmPassword")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Show Confirm Password
                    </label>
                  </div>
                  </div>


                  <div className="input-box">
                    <span className="details">OTP</span>
                    <input
                      type="password"
                      placeholder="Enter your otp"
                      required
                      onChange={(e) => setNewOTP(e.target.value)}
                    />
                  </div>
                  <small className="text-danger h5">
                    Note: Kindly review your Email's spam or bin folder for the
                    OTP.
                  </small>
                </div>
                <div className="otp-button d-flex justify-content-around">
                  <button
                    onClick={SendOTP}
                    style={{ backgroundColor: "#007bff" }}
                    id="send"
                  >
                    Send OTP
                  </button>
                  <button onClick={verifyOTP} id="verify">
                    Verify OTP
                  </button>
                </div>

                <div className="sreg-button">
                  <button type="submit" id="reg" onClick={Submit}>
                    REGISTER
                  </button>
                </div>
                <div className="signup-link text-center">
                  Already have an account? <a href="/?page=true">Login</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <Footer />
        </section>
      </div>
    </>
  );
};
